import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'xdh-map/lib/xdhmap.css';
import 'vuescroll/dist/vuescroll.css';
import posIcon from '@/assets/others/map/location.png';
import { XdhMap, XdhMapType, XdhMapDraw, XdhMapGeoLayer, XdhMapLine, XdhMapPlacement } from 'xdh-map';
export default {
  name: 'MapGetArea',
  components: {
    XdhMap: XdhMap,
    XdhMapType: XdhMapType,
    XdhMapDraw: XdhMapDraw,
    XdhMapGeoLayer: XdhMapGeoLayer,
    XdhMapLine: XdhMapLine,
    XdhMapPlacement: XdhMapPlacement
  },
  mounted: function mounted() {
    this.mapCenter = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];
  },
  data: function data() {
    return {
      // state: yaan,
      mapAreaList: [],
      visible: false,
      mapCenter: [118.047928, 24.613341],
      posIcon: posIcon,
      title: '',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      searchurl: 'https://restapi.amap.com/v3/config/district?key=44641f38739649861c9d7d31f69b4ac2',
      maptype: 'Amap2'
    };
  },
  methods: {
    changeMap: function changeMap(e) {
      this.maptype = e.target.value;

      if (e.target.value == 'Amap') {
        this.$refs.myMap.changeType(e.target.value);
      } else {
        this.$refs.myMap.changeType('Amap2');
      }
    },
    searchMap: function searchMap() {
      var _this = this;

      if (this.title) {
        //可用filter限制搜索区域,限制参数填入adcode
        // const surl=this.searchurl+"&filter=511800&keywords="+this.title
        var surl = this.searchurl + '&keywords=' + this.title;

        var _that = this;

        this.$jsonp(surl).then(function (res) {
          if (res && res.districts && res.districts.length > 0) {
            var location = res.districts[0].center.split(',');

            _this.$refs.myMap.moveTo(location);
          } else {
            _that.$message.warning('未查询到对应数据!');
          }
        });
      } else {
        that.$message.warning('请输入需要搜索的关键字');
      }
    },
    mapReady: function mapReady() {
      this.$refs.myMap.resize();
      this.$refs.myMap.moveTo(this.mapCenter);
    },
    show: function show(mapAreaList) {
      if (mapAreaList) {
        var pointList = mapAreaList.split(':');
        this.mapAreaList = pointList.map(function (v) {
          return v.split('-').map(function (item) {
            return item.split(',');
          });
        });
        this.mapAreaList.forEach(function (item) {
          item.push(item[0]);
        });
      }

      this.visible = true;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.mapReady();
    },
    handleOk: function handleOk() {
      this.$emit('mapChange', this.mapAreaList);
      this.handleCancel();
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    drawLine: function drawLine() {
      this.finish();
      this.$refs.polygon.draw();
    },
    modify: function modify() {
      this.$refs.polygon.modify();
    },
    finish: function finish() {
      this.$refs.polygon.finish();
    },
    clear: function clear() {
      this.$refs.polygon.clear();
      this.mapAreaList = [];
    },
    drawend: function drawend(e) {
      console.log('drawend', e.target.sketchCoords_);
      this.mapAreaList.push(e.target.sketchCoords_[0]);
      this.mapAreaList.forEach(function (item) {
        item.push(item[0]);
      });
    },
    drawstart: function drawstart(e) {
      console.log('drawstart', e);
    }
  }
};